(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bullet-view"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector(`[data-bullet-view][data-section-id="{{ section_id }}"]`);
    if (!section) return;

    const buttons = Array.from(section.querySelectorAll('[data-bullet]'));
    if (!buttons.length) return;

    const titleEl = section.querySelector('[data-detail-title]');
    const descEl = section.querySelector('[data-detail-description]');
    const imageFigure = section.querySelector('[data-detail-figure]');
    const imageEl = section.querySelector('[data-detail-image]');
    const actionBtn = section.querySelector('[data-detail-button]');
    const defaultBtnText = actionBtn ? actionBtn.dataset.defaultText || actionBtn.textContent : '';

    const activate = (button) => {
      if (!button) return;

      buttons.forEach((btn) => {
        const isActive = btn === button;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      const title = button.dataset.title || '';
      const description = button.dataset.description || '';
      const image = button.dataset.image || '';
      const imageAlt = button.dataset.imageAlt || title || '';
      const url = button.dataset.url || '';
      const buttonText = button.dataset.buttonText || defaultBtnText || 'Learn more';

      if (titleEl) {
        titleEl.textContent = title;
      }

      if (descEl) {
        descEl.innerHTML = description;
      }

      if (imageEl) {
        if (image) {
          imageEl.src = image;
          imageEl.alt = imageAlt;
          imageEl.removeAttribute('hidden');
          if (imageFigure) {
            imageFigure.removeAttribute('hidden');
          }
        } else {
          imageEl.setAttribute('hidden', 'true');
          if (imageFigure) {
            imageFigure.setAttribute('hidden', 'true');
          }
        }
      }

      if (actionBtn) {
        if (url) {
          actionBtn.href = url;
          actionBtn.textContent = buttonText;
          actionBtn.removeAttribute('hidden');
        } else {
          actionBtn.setAttribute('hidden', 'true');
        }
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('mouseenter', () => activate(button));
      button.addEventListener('focus', () => activate(button));
    });

    const initial = buttons.find((btn) => btn.classList.contains('is-active')) || buttons[0];
    activate(initial);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo {
    constructor(sectionId) {
      this.section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.section) return;

      this.videoContainer = this.section.querySelector('.hero__video');
      this.video = this.videoContainer ? this.videoContainer.querySelector('video') : null;
      this.image = this.section.querySelector('.hero__image');
      this.youtubeIframe = this.section.querySelector('.hero__youtube-iframe');

      this.init();
    }

    init() {
      // Check if mobile (hide video on small screens for performance)
      const isMobile = window.innerWidth < 768;
      const showVideoOnMobile = this.section.dataset.mobileVideo === 'true';

      if (isMobile && !showVideoOnMobile) {
        this.hideVideo();
        return;
      }

      // Handle Shopify video
      if (this.video) {
        // Required for iOS Safari inline autoplay
        this.video.setAttribute('playsinline', '');
        this.video.setAttribute('webkit-playsinline', '');
        this.video.setAttribute('muted', '');
        this.video.muted = true;
        this.video.playsInline = true;

        this.video.addEventListener('loadeddata', () => {
          this.showVideo();
        });

        this.video.addEventListener('error', () => {
          this.hideVideo();
        });

        // Attempt to play
        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {
            this.hideVideo();
          });
        }
      }

      // Handle YouTube video
      if (this.youtubeIframe) {
        setTimeout(() => {
          this.showVideo();
        }, 1000);
      }
    }

    showVideo() {
      if (this.videoContainer) {
        this.videoContainer.classList.add('hero__video--loaded');
      }
    }

    hideVideo() {
      if (this.videoContainer) {
        this.videoContainer.style.display = 'none';
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new HeroVideo('{{ section.id }}');
    });
  } else {
    new HeroVideo('{{ section.id }}');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Sort form auto-submit
    const sortForm = document.querySelector('[data-sort-form]');
    if (sortForm) {
      const select = sortForm.querySelector('select[name="sort_by"]');
      if (select) {
        select.addEventListener('change', () => sortForm.requestSubmit());
      }
    }

    // Filter dropdowns auto-submit
    const filterSelects = document.querySelectorAll('[data-filter-select]');
    filterSelects.forEach(select => {
      select.addEventListener('change', () => {
        const form = select.closest('form');
        if (form) form.requestSubmit();
      });
    });

    // Price filter popup toggle
    const priceTriggers = document.querySelectorAll('[data-price-trigger]');
    priceTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = trigger.nextElementSibling;
        if (popup) {
          popup.classList.toggle('is-open');
        }
      });
    });

    // Close price popup when clicking outside
    document.addEventListener('click', (e) => {
      const popups = document.querySelectorAll('[data-price-popup]');
      popups.forEach(popup => {
        const dropdown = popup.closest('.collection-grid__filter-dropdown--price');
        if (dropdown && !dropdown.contains(e.target)) {
          popup.classList.remove('is-open');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
